export default "__VITE_ASSET__YHKjuBfH__"